import type {
	IndicatorComparisonPayload,
	IndicatorPeriodPayload,
} from '@Application/Indicators/Actions/indicatorPeriodPayload';

export type BeneficiaryIndicatorsPayload = {
	queryKey: string;
	period: IndicatorPeriodPayload;
	active: number;
	created: IndicatorComparisonPayload;
};

export type BeneficiaryIndicatorsFetchedAction = {
	type: 'BENEFICIARY_INDICATORS_FETCHED';
	payload: BeneficiaryIndicatorsPayload;
};

export default (payload: BeneficiaryIndicatorsPayload): BeneficiaryIndicatorsFetchedAction => ({
	type: 'BENEFICIARY_INDICATORS_FETCHED',
	payload,
});
